/**
 * Schemas supported in Phase 1.
 * Adding a schema: append here, add the matching prompt in supabase/functions/extract/prompts.ts,
 * and update the PRD.md §4 use-cases table.
 */

export const SCHEMAS = {
  receipt: {
    id: "receipt",
    label: "Receipt",
    description: "Restaurant, retail, or expense receipts. Extracts vendor, date, total, line items.",
    icon: "🧾",
  },
  invoice: {
    id: "invoice",
    label: "Invoice",
    description: "B2B invoices. Extracts invoice number, dates, vendor, bill-to, line items, totals.",
    icon: "📄",
  },
  business_card: {
    id: "business_card",
    label: "Business Card",
    description: "Networking cards. Extracts name, title, company, contact info.",
    icon: "💼",
  },
  free_text: {
    id: "free_text",
    label: "Free Text",
    description: "Generic OCR — extract all text from any document.",
    icon: "📝",
  },
  pdf_to_text: {
    id: "pdf_to_text",
    label: "PDF to Text",
    description: "Convert a PDF into clean structured text with headings, paragraphs, and lists preserved.",
    icon: "📑",
  },
} as const;

export type SchemaId = keyof typeof SCHEMAS;

export const SCHEMA_IDS = Object.keys(SCHEMAS) as SchemaId[];
